<template>
    <div id="separation-element-settings">
        <div class="form-field">
            <label for="line-color" class="form-label">{{ $t("form.lineColor") }}</label>
            <input
                type="color"
                id="line-color"
                class="form-input"
                v-model="item.separationElement.separationColor"
                @input="setSeparationColor(item.separationElement.separationColor)"
            >
            <small class="form-description">{{ $t("form.separatorColorInfo") }}</small>
        </div>

<!--        <div class="form-field">-->
<!--            <label for="element-style" class="form-label">Ayırma Elemanı Stili</label>-->
<!--            <select-->
<!--                id="element-style"-->
<!--                class="form-select"-->
<!--                v-model="separatorStyle"-->
<!--                @input="setSeparatorStyle(separatorStyle)"-->
<!--            >-->
<!--                <option value="solid">Düz</option>-->
<!--                <option value="dotted">Kesik Çizgi</option>-->
<!--                &lt;!&ndash; Diğer seçenekler burada yer alabilir &ndash;&gt;-->
<!--            </select>-->
<!--            <small class="form-description">Ayırma elemanınız için bir stil seçin</small>-->
<!--        </div>-->

        <div class="form-field">
            <label for="element-height" class="form-label">{{ $t("form.separatorHeight") }}</label>
            <input
                type="number"
                id="element-height"
                class="form-input"
                v-model="item.separationElement.separatorHeight"
                @input="setSeparatorHeight(item.separationElement.separatorHeight)"
            >
            <small class="form-description">{{ $t("form.separatorHeightInfo") }}</small>
        </div>

        <div class="form-field">
            <label for="bottom-margin" class="form-label">{{ $t("form.bottomSpace") }}</label>
            <input
                type="number"
                id="bottom-margin"
                class="form-input"
                v-model="item.separationElement.separatorBottom"
                @input="setSeparatorBottom(item.separationElement.separatorBottom)"
            >
            <small class="form-description">{{ $t("form.bottomSpaceInfo") }}</small>
        </div>

        <div class="form-field">
            <label for="top-margin" class="form-label">{{ $t("form.topSpace") }}</label>
            <input
                type="number"
                id="top-margin"
                class="form-input"
                v-model="item.separationElement.separatorTop"
                @input="setSeparatorTop(item.separationElement.separatorTop)"
            >
            <small class="form-description">{{ $t("form.topSpaceInfo") }}</small>
        </div>

        <div class="form-field">
            <label for="side-margin" class="form-label">{{ $t("form.sideSpace") }}</label>
            <input
                type="number"
                id="side-margin"
                class="form-input"
                v-model="item.separationElement.separatorSide"
                @input="setSeparatorSide(item.separationElement.separatorSide)"

            >
            <small class="form-description">{{ $t("form.sideSpaceInfo") }}</small>
        </div>

        <div class="form-field">
            <label class="form-label">Görünürlük</label>
            <div class="toggle" @click="toggleVisibility">
                <span class="toggle-option" :class="{ active: visibility }">{{ visibility ? 'Görünür' : 'Gizli' }}</span>
            </div>
            <small class="form-description">Bu alanın form üzerinde görünür olup olmayacağını belirler</small>
        </div>

        <div class="form-field">
            <label for="slug-input" class="form-label">URL Parametresi</label>
            <input
                type="text"
                id="slug-input"
                class="form-input"
                placeholder="separationElement"
                v-model="slug"
                @input="setSlug($event.target.value)"
            >
            <small class="form-description">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>

        <!--        <div class="form-field">-->
        <!--            <label class="form-label">Alanı Kopyala</label>-->
        <!--            <button class="duplicate-button" @click="duplicateField">DUPLICATE</button>-->
        <!--            <small class="form-description">Bu alanın tüm kayıtlı ayarlarını koruyarak bir kopyasını oluşturun</small>-->
        <!--        </div>-->
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "SeparationElementSettings",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            separationColor: this.item.separationElement.separationColor,
            separatorStyle: this.item.separationElement.separatorStyle,
            separatorHeight: this.item.separationElement.separatorHeight,
            separatorBottom: this.item.separationElement.separatorBottom,
            separatorTop: this.item.separationElement.separatorTop,
            separatorSide: this.item.separationElement.separatorSide,
            visibility: this.item.visibility !== undefined ? this.item.visibility : true,
            slug: this.item.slug || '',
            updateTimer: null,
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        duplicateField() {
            console.log("Alan kopyalandı");
        },
        setSeparationColor(color) {
            if (color.startsWith("#") && color.length === 7) {
                this.separationColor = color;
                this.$emit("update-separation-color", color);
                this.updateFields();
            } else {
                console.error("Invalid color format. Please use #RRGGBB format.");
            }
        },
        setSeparatorStyle(style) {
            this.separatorStyle = "solid";
            this.$emit("update-separator-style", style);
            this.updateFields();
        },
        setSeparatorHeight(height) {
            this.separatorHeight = height;
            this.$emit("update-separator-height", height);
            this.updateFields();
        },
        setSeparatorBottom(bottom) {
            this.separatorBottom = bottom;
            this.$emit("update-separator-bottom", bottom);
            this.updateFields();
        },
        setSeparatorTop(top) {
            this.separatorTop = top;
            this.$emit("update-separator-top", top);
            this.updateFields();
        },
        setSeparatorSide(side) {
            this.separatorSide = side;
            this.$emit("update-separator-side", side);
            this.updateFields();
        },
        toggleVisibility() {
            this.visibility = !this.visibility;
            this.updateFields();
            this.$emit('update-visibility', this.visibility);
        },
        setSlug(slug) {
            this.slug = this.sanitizeSlug(slug);
            this.updateFields();
        },
        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },
        updateFields() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                const updateFields = {
                    visibility: self.visibility,
                    slug: self.slug,
                    separationElement: {
                        separationColor: self.separationColor,
                        separatorStyle: self.separatorStyle,
                        separatorHeight: self.separatorHeight,
                        separatorBottom: self.separatorBottom,
                        separatorTop: self.separatorTop,
                        separatorSide: self.separatorSide,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
            }, 800);
        },
    },
};
</script>

<style lang="scss" scoped>
#separation-element-settings {
    padding: 8px 12px 24px 12px;

    .form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;

        .form-label {
            margin-bottom: 6px;
            font-weight: 600;
            color: #374151;
            font-size: 0.875rem;
            letter-spacing: 0.025em;
        }

        .form-input {
            padding: 8px 12px;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            background-color: #ffffff;
            color: #374151;
            font-size: 0.875rem;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;
            width: 100%;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
            }

            &::placeholder {
                color: #9ca3af;
            }
        }

        .form-description {
            margin-top: 4px;
            font-size: 0.75rem;
            color: #9ca3af;
            line-height: 1.3;
        }
    }
}
</style>
